import { useCallback, useEffect, useState } from 'react';
import { Client } from '../types/client.types';
import { listClients } from '../services/ClientService';

/**
 * La lista solo se pide cuando el modal esta abierto. Antes el fetch vivia
 * dentro de LeftColCart con un console.error, y un fallo de red dejaba el
 * listado vacio sin ninguna explicacion para el cajero.
 */
export const useClients = (enabled: boolean) => {
    const [clients, setClients] = useState<Client[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const load = useCallback(() => {
        setIsLoading(true);
        setError(null);
        listClients()
            .then((list) => {
                setClients(list);
                setIsLoading(false);
            })
            .catch((err) => {
                setClients([]);
                setError(err?.message || 'No se pudo cargar la lista de clientes.');
                setIsLoading(false);
            });
    }, []);

    useEffect(() => {
        if (!enabled) return;
        load();
    }, [enabled, load]);

    return { clients, setClients, isLoading, error, reload: load };
};
